var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThemenFragenUebersicht',{attrs:{"ready":_vm.ready,"themen":_vm.themen,"error":_vm.error,"show-freigegeben":_vm.showFreigegeben}})}
var staticRenderFns = []

export { render, staticRenderFns }